import React, { useState, useEffect } from "react";
import { Get_Schools_Fuzzy_Search } from "../../pages/Schools/api/Get_Schools_Fuzzy_Search";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";
import { Get_One_From_MongoDB } from "../../api/Get_One_From_MongoDB";
import { StaffuseAuth } from "../../security/StaffuseAuth";

function SearchSchoolsSetSchool({ handleChoose, Attendee }) {
  const { logout } = StaffuseAuth();

  //Get Schools
  const [Schools, setSchools] = useState([]);
  const [searchSchoolName, setSearchSchoolName] = useState("");
  const [searchSchoolCountry, setSearchSchoolCountry] = useState("");
  const [searchSchoolPD, setSearchSchoolPD] = useState("");
  const handleSearchSchoolName = (event) => {
    setSearchSchoolName(event.target.value);
  };
  const handleSearchSchoolCountry = (event) => {
    setSearchSchoolCountry(event.target.value);
  };
  const handleSearchSchoolPD = (event) => {
    setSearchSchoolPD(event.target.value);
  };
  function handleSubmitSchoolSearch(e) {
    e.preventDefault();
    Get_Schools_Fuzzy_Search(
      "Schools",
      "All_Schools",
      {
        searchName: searchSchoolName,
        searchCountry: searchSchoolCountry,
        searchPD: searchSchoolPD,
        limit: Number(100),
      },
      setSchools,
      logout
    );
  }

  //If already got a school, search for it
  const [KnownSchool, setKnownSchool] = useState({});
  useEffect(() => {
    if (
      Attendee.BasicInfo &&
      Attendee.BasicInfo.School_id &&
      Attendee.BasicInfo.School_id.length > 0
    ) {
      Get_One_From_MongoDB(
        "Schools",
        "All_Schools",
        Attendee.BasicInfo.School_id,
        setKnownSchool,
        logout
      );
    }
  }, [Attendee?.BasicInfo?.School_id]);

  //add KnownSchool to the array of Schools
  if (
    KnownSchool &&
    KnownSchool._id &&
    !Schools.find((School) => School._id === KnownSchool._id)
  ) {
    setSchools([...Schools, KnownSchool]);
  }

  return (
    <>
      <TextField
        key="handleSearchSchoolName"
        name="handleSearchSchoolName"
        label="Search School Name"
        variant="outlined"
        margin="normal"
        fullWidth
        value={searchSchoolName}
        onChange={(e) => handleSearchSchoolName(e)}
        InputProps={{
          style: {
            backgroundColor: "white",
          },
        }}
      />{" "}
      <TextField
        key="handleSearchSchoolCountry"
        name="handleSearchSchoolCountry"
        label="Search School Country"
        variant="outlined"
        margin="normal"
        fullWidth
        value={searchSchoolCountry}
        onChange={(e) => handleSearchSchoolCountry(e)}
        InputProps={{
          style: {
            backgroundColor: "white",
          },
        }}
      />{" "}
      <TextField
        key="handleSearchSchoolPD"
        name="handleSearchSchoolPD"
        label="Search School PD"
        variant="outlined"
        margin="normal"
        fullWidth
        value={searchSchoolPD}
        onChange={(e) => handleSearchSchoolPD(e)}
        InputProps={{
          style: {
            backgroundColor: "white",
          },
        }}
      />{" "}
      <Button
        variant="contained"
        color="primary"
        onClick={(e) => handleSubmitSchoolSearch(e)}
      >
        Search School
      </Button>
      <TextField
        label="School_id"
        name="School_id"
        variant="outlined"
        margin="normal"
        value={
          Attendee.BasicInfo && Attendee.BasicInfo.School_id
            ? Attendee.BasicInfo.School_id
            : ""
        }
        onChange={handleChoose}
        fullWidth
        sx={{ marginBottom: "10px" }}
        select
        InputProps={{
          style: {
            backgroundColor: "white",
          },
        }}
      >
        <MenuItem key={""} value={""}>
          -----
        </MenuItem>

        {Schools.map((School) => (
          <MenuItem key={School._id} value={School._id}>
            {School.School_Name}, {School.School_Country},{" "}
            {School.School_PostCode}, {School.School_PD},
          </MenuItem>
        ))}
      </TextField>
    </>
  );
}

export default SearchSchoolsSetSchool;
